/* eslint-disable import/prefer-default-export */
export const themes = {
    THETA: 'THETA',
    ALPHA: 'ALPHA',
    BETA: 'BETA',
    GAMMA: 'GAMMA',
    DELTA: 'DELTA',
    EPSILON: 'EPSILON',
    LONG_TERM_DEBT: 'LONG_TERM_DEBT',
    SHORT_TERM_DEBT: 'SHORT_TERM_DEBT',
    POSITIVE: 'POSITIVE',
    NEGATIVE: 'NEGATIVE',
    WHITE: 'WHITE',
};
